import { Component } from '@angular/core';
import { StatusCardConfig } from '@shared/components/widgets/status-card/status-card-config';
import { DashboardService } from '@app/api/dmc';
import { StatusCardComponent } from '@shared/components/widgets/status-card/status-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-elvarme',
  imports: [
    StatusCardComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard-elvarme.component.html',
})
export class DashboardElvarmeComponent {

  public electricalHeatingCreate: StatusCardConfig = {
    label: 'dashboard.query.missingelectricalheating.title',
    route: ['/dashboard', 'query', 'missingelectricalheating'],
    serviceCallback: () => this.dashboardService.dashboardGetMissingElectricalHeatingGet(),
  };

  public electricalHeatingRemove: StatusCardConfig = {
    label: 'dashboard.query.removalelectricalheating.title',
    route: ['/dashboard', 'query', 'removalelectricalheating'],
    serviceCallback: () => this.dashboardService.dashboardGetRemovalOfElectricalHeatingGet(),
  };

  constructor(private readonly dashboardService: DashboardService) {}
}
